module.exports = __webpack_public_path__ + "static/media/delete_x.be178bfc.svg";